/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {datesIcon} from '../../../../v1/blocks/WidgetValues/Date/index';

export const BLOCK_NAME = 'snap_get_date_value_v3';

function defineBlock(context) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField('get')
                .appendField(new Blockly.FieldImage(datesIcon, 30, 30, 'dates icon', null), 'datesIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context, 'date', undefined, '- select -'), 'ID');
            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, ['Date', 'String']);
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Get the date inside a datepicker widget.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#dates');
        },

        onchange: function() {
            const datesIconField = this.getField('datesIcon');
            if (datesIconField?.imageElement_) {
                datesIconField.setTooltip('Date');
            }
        },
    }
}

function defineGenerators() {
    return {
        'JavaScript': function(block){
            const id = block.getFieldValue('ID');
            const rawDateValue = `Snap.widgets.datepicker.getValue('${id}')`;
            const dateObject = `new Date(${rawDateValue})`;
            const dateString = rawDateValue;

            let code = dateString;
            const parentConnection = block.outputConnection?.targetConnection;
            if (parentConnection) {
                // check how the output of this block is being used
                const acceptedTypes = typeof parentConnection.getCheck === 'function'
                    ? parentConnection.getCheck() : parentConnection.check_;
                if (Array.isArray(acceptedTypes) ? acceptedTypes.includes('Date') : acceptedTypes === 'Date') {
                    // it is being used in a context that accepts Date objects, return a Date object
                    code = dateObject;
                }
            }
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const GetDateValue = function (props) {
    const name = BLOCK_NAME;
    GetDateValue.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (!props.widgets || (props.widgets.length < 1)) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget && (props.widget.id!==undefined)?
                <field name='ID'>{props.widget.id}</field>
                : null
            }
        </block>
    );
};

// define prop types for better documentation and type checking (to fix SQ issues)
GetDateValue.propTypes = {
    context: PropTypes.any,
    widgets: PropTypes.arrayOf(PropTypes.any),
    widget: PropTypes.shape({
        id: PropTypes.any
    })
};

export default GetDateValue;
